<template>
  <div class="softwareCopyright">
    <h3>
      <p class="el-icon-arrow-left" @click="showTable">返回</p>
      <b></b>
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>软件著作权</el-breadcrumb-item>
      </el-breadcrumb>
    </h3>
    <table>
      <thead class="softwareCopyright-table-header">
        <tr>
          <td>序号</td>
          <td>软件名称</td>
          <td>登记号</td>
          <td>版本号</td>
          <td>分类号</td>
          <td>登记批准日期</td>
          <td>软件简称</td>
        </tr>
      </thead>
      <tbody
        class="softwareCopyright-table-body"
        v-if="softwareCopyrightList.length != 0"
      >
        <tr v-for="(item, index) in itemList" :key="index">
          <td>{{ getIndex(index) }}</td>
          <td>{{ item.full_name ? item.full_name : "---" }}</td>
          <td>{{ item.reg_num ? item.reg_num : "---" }}</td>
          <td>{{ item.software_version ? item.software_version : "---" }}</td>
          <td>{{ item.cat_num ? item.cat_num : "---" }}</td>
          <td>{{ item.reg_time ? item.reg_time : "---" }}</td>
          <td>{{ item.simple_name ? item.simple_name : "---" }}</td>
        </tr>
      </tbody>
      <tbody v-else class="softwareCopyright-table-body">
        <tr class="notList">
          <td colspan="7">暂无数据</td>
        </tr>
      </tbody>
    </table>
    <el-pagination
      background
      layout="prev, pager, next"
      :page-size="pageSize"
      :total="softwareCopyrightList.length"
      @current-change="handleCurrentChange"
    >
    </el-pagination>
  </div>
</template>

<script>
import { softwareListByAuthor } from "@/api/patentQuery.js";
export default {
  props: ["name"],
  data() {
    return {
      pageSize: 5,
      currentPage: 1,
      softwareCopyrightList: [],
      itemList: []
    };
  },
  mounted() {
    softwareListByAuthor(this.name).then(res => {
      // console.log(res, "softwareListByAuthor");
      if (res.status == 0) {
        let newArr = res.data.data;
        // newArr.pop();
        this.softwareCopyrightList = newArr;
        this.handleCurrentChange(1);
      }
    });
    this.handleCurrentChange(1);
  },
  methods: {
    handleCurrentChange(val) {
      this.itemList = this.softwareCopyrightList.slice(
        (val - 1) * this.pageSize,
        val * this.pageSize
      );
      this.currentPage = val;
    },
    //获取序号
    getIndex(index) {
      return index + 1 + this.currentPage * this.pageSize - this.pageSize;
    },
    indexMethod(index) {
      return index * 2;
    },
    //翻转
    showTable() {
      this.$emit("unshowOne");
    }
  }
};
</script>

<style lang="scss">
.softwareCopyright {
  width: 100%;
  h3 {
    display: flex;
    align-items: center;
    margin-bottom: 17px;
    p {
      margin-right: 8px;
      font-size: 15px;
      cursor: pointer;
    }
    b {
      width: 2.5px;
      height: 14px;
      background: #1478f0;
      display: block;
      margin-right: 5px;
    }
    .el-breadcrumb {
      .el-breadcrumb__item:nth-child(1) {
        .el-breadcrumb__inner {
          font-size: 16px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: rgba(51, 51, 51, 1);
          line-height: 22px;
        }
      }
      .el-breadcrumb__item:nth-child(2) {
        .el-breadcrumb__inner {
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: rgba(20, 120, 240, 1);
          line-height: 22px;
        }
      }
    }
  }
  table {
    width: 100%;
    text-align: center;
    .softwareCopyright-table-header {
      width: 100%;
      tr {
        width: 100%;
        td {
          padding: 15px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          border: 1px solid #e4eef6;
          background: #f2f9fc;
        }
      }
    }
    .softwareCopyright-table-body {
      width: 100%;
      tr {
        width: 100%;
        td {
          padding: 15px;
          border: 1px solid #e4eef6;
          img {
            width: 60px;
            height: 34px;
            border: 2px solid #ccc;
            display: inline-block;
          }
        }
      }
    }
  }
  .el-pagination {
    display: flex;
    justify-content: center;
    margin: 19px 0;
  }
}
</style>
